import React from "react"
import {useStore, useDispatch} from "../Store"
import {useTranslation} from "react-i18next"
import "../i18n"
import {useMediaQuery} from "@material-ui/core"
import {makeStyles} from "@material-ui/core/styles"
import Tab from "@material-ui/core/Tab"
import Tabs from "@material-ui/core/Tabs"
import {red} from "@material-ui/core/colors"
import {useTheme} from "../hooks"
import {isAmOne, returnToTop} from "../common"

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: (props) => props.theme.palette.background.default,
  },
  tabs: {
    color: red.A400,
    display: 'inline-block',
  },
  switch: {
    marginTop: 5,
  },
  wrapper: {
    textAlign: `center`,
  }
}))

export default function PerspectiveBar() {
  const {t} = useTranslation()
  const {dispatch} = useDispatch()
  const {
    store: {tabs, mainType, mainGroup, mainLabel, perspective, themeColor},
  } = useStore()
  const theme = useTheme(themeColor)
  const isMobile = useMediaQuery(theme.breakpoints.down(`xs`))
  const classes = useStyles({
    isMobile,
    theme,
  })

  const handleChange = (event, newValue) => {
    dispatch({
      type: `PERSPECTIVE`,
      perspective: newValue,
    })

    returnToTop()
  }

  const getLabel = (tab) => {
    switch (mainType[tab]) {
      case `FX`:
      case `FXSET`:
        return t(`fx`)
      case `EQSET`:
        return isAmOne() ? mainGroup[tab] : t(mainLabel[tab]) /* i18next-extract-disable-line */
      case `EQ`:
        return t(mainLabel[tab]) /* i18next-extract-disable-line */
    }
  }

  const displayTabs = Object.entries(tabs).map(
    /* i18next-extract-disable-next-line */
    ([k, i]) => (<Tab key={i} label={getLabel(i)} value={i} />)
  )

  return (
    <div className={classes.wrapper}>
      <Tabs id={`perspective_bar`} className={classes.tabs} value={perspective} onChange={handleChange} centered>
        {displayTabs}
      </Tabs>
    </div>
  )
  
}
